import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import PositionPriceTrailDocs from '../../../../documentation/PositionPriceTrailDocumentation';

function PositionPriceTrailModule({ state }) {
  const [
    positionPriceTrail,
    dispatchPositionPriceTrail,
    ,
    setPositionPriceTrailEnabled,
  ] = state;

  const [amountDisplay, setAmountDisplay] = useState('');

  useEffect(() => {
    setPositionPriceTrailEnabled(true);
  }, []);
  useEffect(() => {
    setAmountDisplay(positionPriceTrail.amount ?? 0);
  }, [state]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={PositionPriceTrailDocs} /> Position Price Trail 
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>Amount</p>
          <NumberInputWithUnit
            inputWidth="70px"
            direction="left"
            type="number"
            value={amountDisplay}
            setValue={setAmountDisplay}
            onBlur={(value) => dispatchPositionPriceTrail({ amount: value })}
          >
            $
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
}
PositionPriceTrailModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default PositionPriceTrailModule;
